/**
 * @file index.tsx
 *
 * @fileoverview Renders blog search loading page.
 */

import Layout from '~/jobiqo/components/Layout';
import { BLOGS_PER_PAGE } from '~/jobiqo/pages/blogs';
import { Grid } from '~/vcl/atoms/06-layout/04-grid';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { BlogTeaserPlaceholder } from '~/vcl/organisms/05-placeholders/08-blog/01-teaser';
import { SearchFormPlaceholder } from '~/vcl/organisms/05-placeholders/07-search-form';

export default function BlogSearchLoading() {
  return (
    <Layout fullWidthContainer={true}>
      <Main>
        <Spacing size="large" />
        <SearchFormPlaceholder />
        <Spacing size="medium" />
        <Grid columns={[1, 2, 3]}>
          {new Array(BLOGS_PER_PAGE)
            .fill(BlogTeaserPlaceholder)
            .map((Component, index) => (
              <Cell key={index}>
                <Component />
              </Cell>
            ))}
        </Grid>
      </Main>
    </Layout>
  );
}
export { BlogSearchLoading };
